import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import { localize } from 'react-localize-redux';

import { SyncLoader } from 'halogenium';

import * as bookings from 'actions/bookingsActions';
import ShowingForm from 'components/bookings/showings_form';
import ShowingResults from 'components/bookings/bookingResults';

import { daysFromNow } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';

const mapStateToProps = function(state) {
  return {
    showSelectBooking: state.bookings.select_availability,
    timeAvailability: state.bookings.timeAvailability,
    isLoading: state.bookings.isLoading,
    dialogOpen: state.bookings.dialogOpen,
    bookingError: state.bookings.showBookingError,
    errorMessage: state.bookings.errorMessage,
    moveInDate: state.userTypes.moveInDate,
  };
};

export default connect(mapStateToProps, { ...bookings })(
  localize()(
    class ShowingSelector extends Component {
      handleClose = () => {
        this.props.closeDialog();
      };

      dialogClosed = () => {
        return !this.props.dialogOpen;
      };

      render() {
        const style = {
          table_header: {
            margin: '5px -20px 10px -20px',
            backgroundColor: '#f1f1f1',
            padding: '5px 10px',
            fontSize: '14px',
            fontWeight: '800',
          },
        };

        return (
          <div className="row" style={{ fontSize: '15px', marginTop: '15px' }}>
            <CSSTransitionGroup
              transitionName="show_bookings"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              <div>
                <div className="row" style={style.table_header}>
                  <div style={{ textAlign: 'center' }}>
                    <span style={{ textAlign: 'center' }}>{this._renderTitle()}</span>
                  </div>
                </div>

                <div
                  className="row"
                  id="modify_showing"
                  style={{
                    fontSize: '15px',
                    marginTop: '10px',
                    color: '#4e4e4e',
                  }}
                  ref="modify_showing"
                >
                  <ShowingForm
                    onSubmit={this.props.submitForm}
                    minDate={this.props.minDateOverride || this.props.moveInDate}
                    amenityType={
                      this.props.amenityBookingDetails
                        ? this.props.amenityBookingDetails.amenity_type
                        : undefined
                    }
                    amenityDurationType={
                      this.props.amenityBookingDetails
                        ? this.props.amenityBookingDetails.amenity_duration_type
                        : undefined
                    }
                    maxDate={daysFromNow(365)}
                    maxBookingTime={
                      deepDiver(this.props.amenityBookingDetails, 'max_booking_time') || null
                    }
                    minBookingTime={
                      deepDiver(this.props.amenityBookingDetails, 'min_booking_time') || null
                    }
                    hideUnitTypes={this.props.hideUnitTypes}
                  />
                </div>

                <div className="row" style={{ marginTop: '5px' }}>
                  <div className="col-xs-12">
                    {this._renderMaxHourDisclaimer()}
                    <p
                      style={{
                        fontSize: '11px',
                        marginBottom: 0,
                        textAlign: 'center',
                      }}
                    >
                      {this.props.translate('amenities.bookingWarning')}
                    </p>
                  </div>
                </div>

                {this.props.isLoading && (
                  <div>
                    <p style={{ textAlign: 'center', marginTop: '30px' }}>
                      <SyncLoader color="#ff5656" size="16px" margin="4px" />
                    </p>
                    <p style={{ textAlign: 'center', fontSize: '12px' }} id="loader">
                      {this.props.translate('amenities.checkingAvailability')}
                    </p>
                  </div>
                )}

                {(this.props.bookingError || this.props.errorMessage) && (
                  <h6 style={{ textAlign: 'center', marginTop: '30px' }}>
                    {this.props.errorMessage}
                  </h6>
                )}

                {this.props.showSelectBooking && (
                  <div
                    className="row"
                    id="modify_showing"
                    style={{
                      fontSize: '15px',
                      marginTop: '10px',
                      color: '#4e4e4e',
                    }}
                    ref="modify_showing"
                  >
                    <ShowingResults
                      isLucky={this.props.timeAvailability.lucky}
                      timeAvailability={this.props.timeAvailability.availabilities}
                      bookingId={this.props.bookingId}
                      dialogIsClosed={this.dialogClosed}
                      closeDialog={this.handleClose}
                      amenityBookingDetails={this.props.amenityBookingDetails}
                      toggleBookingDialog={this.props.toggleBookingDialog}
                      fullScreen={this.props.fullScreen}
                      onComplete={this.props.onComplete}
                      bookingNotes={this.props.bookingNotes}
                    />
                  </div>
                )}
              </div>
            </CSSTransitionGroup>
          </div>
        );
      }

      _renderMaxHourDisclaimer = () => {
        const { amenityBookingDetails } = this.props;
        if (!deepDiver(amenityBookingDetails, 'max_booking_time')) return null;
        if (amenityBookingDetails.max_booking_time === 0) return null;
        return (
          <p style={{ fontSize: '11px', marginBottom: 0, textAlign: 'center' }}>
            {this.props.translate('amenities.maxBookingTime')}{' '}
            {this.props.translate(amenityBookingDetails.time_unit.toLowerCase(), {
              number: amenityBookingDetails.max_booking_time,
            })}
            .
          </p>
        );
      };

      _renderTitle = () => {
        if (!this.props.amenityBookingDetails)
          return this.props.translate('amenities.modifyBooking');

        if (this.props.amenityBookingDetails && this.props.amenityBookingDetails.showing_time)
          return this.props.translate('amenities.modifyBooking');

        return this.props.translate('portalAmenities.bookAmenity');
      };
    }
  )
);
